import type React from 'react';

import { ThemeGlobalStyle } from '@change-corgi/design-system-legacy/core';
import { useTheme } from '@change-corgi/design-system-legacy/theme';

export const GlobalStyle: React.FC = () => {
	const theme = useTheme();

	return (
		<ThemeGlobalStyle
			styles={{
				body: {
					'.tox-hugerte': {
						borderRadius: 'standard',
						borderColor: '#766F81',
					},
					'.tox .tox-edit-area::before': {
						borderColor: '#4771FF',
					},

					'.tox': {
						'& *': {
							fontFamily: `${theme.fonts.body} !important`,
							color: '#403A49 !important',
						},
						// primary button
						'[class="tox-button"]': {
							backgroundImage: 'linear-gradient(90deg, #ffdb00 0%, #ffe600 100%)',
							border: 'none',
							borderRadius: 'standard',
							color: '#403A49',
							fontSize: 14,
							fontWeight: 'bold',
							lineHeight: '24px',
							'&:hover:not(:disabled)': {
								backgroundImage: 'linear-gradient(90deg, #ffb64d 0%, #ffe600 100%)',
								color: '#403A49',
							},
							'&:active:not(:disabled)': {
								backgroundImage: 'linear-gradient(90deg, #fe9311 0%, #ffdb00 100%)',
								color: '#403A49',
							},
						},

						// secondary button
						'.tox-button.tox-button--secondary': {
							bg: 'primary-white',
							borderColor: '#918A9D',
							borderRadius: 'standard',
							borderStyle: 'solid',
							borderWidth: '1px',
							color: '#403A49',
							fontSize: 14,
							fontWeight: 'bold',
							lineHeight: '24px',
							'&:hover:not(:disabled)': {
								backgroundColor: '#403A490D',
								borderColor: '#918A9D',
							},
							'&:active:not(:disabled)': {
								backgroundColor: '#403A491A',
								borderColor: '#918A9D',
							},
						},

						// disables additional navigation in dialogs for features we don't support
						'.tox-dialog__body-nav': {
							display: 'none',
						},

						/* removes the red banner notification hugerte displays on image upload error or when reject() is called */
						'.tox-notifications-container': {
							display: 'none',
						},
					},
				},
			}}
		/>
	);
};
